import Vue from 'vue';

const clickHandler = vnode => vnode.context.$router.go(-1);

Vue.directive('goBack', {
  bind(el, binding, vnode) {
    el.addEventListener('click', () => clickHandler(vnode));
  },
  unbind(el, binding, vnode) {
    el.removeEventListener('click', () => clickHandler(vnode));
  },
});
